const baseRadioOptionsBool = [
  {
    id: 1,
    value: 'true',
    label: 'Yes',
  },
  {
    id: 2,
    value: 'false',
    label: 'No',
  },
];

const baseRadioOptions = [
  {
    id: 1,
    value: 'yes',
    label: 'Yes',
  },
  {
    id: 2,
    value: 'no',
    label: 'No',
  },
];

// Legacy status names are kept, but changing a status saves the matching
// status and assignee from the new Bookkeeper Portal flow (newStatus/assignee).
// See getLegacyStatus for reading them back.
const statusOptions = [
  {
    id: 'PREPARING',
    value: 'PREPARING',
    newStatus: 'PREPARING',
    assignee: 'BOOKKEEPER',
    label: 'Preparing Self Assessment',
    name: 'Preparing Self Assessment',
  },
  {
    id: 'OPEN',
    value: 'OPEN',
    newStatus: 'OPEN',
    assignee: 'CLIENT',
    label: 'Ready to start',
    name: 'Ready to start',
  },
  {
    id: 'READY_FOR_REVIEW',
    value: 'READY_FOR_REVIEW',
    newStatus: 'AWAITING_INFORMATION',
    assignee: 'BOOKKEEPER',
    label: 'Submitted to your accountant',
    name: 'Submitted to your accountant',
  },
  {
    id: 'AWAITING_INFORMATION',
    value: 'AWAITING_INFORMATION',
    newStatus: 'AWAITING_APPROVAL',
    assignee: 'CLIENT',
    label: 'Additional information requested',
    name: 'Additional information requested',
  },
  {
    id: 'PREPARING_SUBMISSION',
    value: 'PREPARING_SUBMISSION',
    newStatus: 'PREPARING_SUBMISSION',
    assignee: 'ACCOUNTANT',
    label: 'Preaparing for submission',
    name: 'Preaparing for submission',
  },
  {
    id: 'AWAITING_APPROVAL',
    value: 'AWAITING_APPROVAL',
    newStatus: 'READY_FOR_REVIEW',
    assignee: 'CLIENT',
    label: 'Review and Approval Requested',
    name: 'Review and Approval Requested',
  },
  {
    id: 'READY_TO_FILE',
    value: 'READY_TO_FILE',
    newStatus: 'READY_TO_FILE',
    assignee: 'ACCOUNTANT',
    label: 'Approved and ready to file to HMRC',
    name: 'Approved and ready to file to HMRC',
    shortName: 'Approved and ready to file',
  },
  {
    id: 'SUBMITTED_TO_HMRC',
    value: 'SUBMITTED_TO_HMRC',
    newStatus: 'SUBMITTED_TO_HMRC',
    assignee: 'CLIENT',
    label: 'Submitted to HMRC',
    name: 'Submitted to HMRC',
  },
];

const accountantSelfAssessmentGeneral = [
  {
    id: 'title',
    name: 'title',
    type: 'title',
    label: 'General',
  },
  {
    id: 'utrNumber',
    name: 'utrNumber',
    type: 'text',
    label: 'UTR Number',
    readOnly: true,
  },
  {
    id: 'email',
    name: 'email',
    type: 'email',
    label: 'Email',
    readOnly: true,
  },
  {
    id: 'phoneNumber',
    name: 'phoneNumber',
    type: 'text',
    label: 'Phone Number',
    readOnly: true,
  },
  {
    id: 'firstName',
    name: 'firstName',
    type: 'text',
    label: 'First name',
    readOnly: true,
  },
  {
    id: 'lastName',
    name: 'lastName',
    type: 'text',
    label: 'Last name',
    readOnly: true,
  },
  {
    id: 'address',
    name: 'address',
    type: 'text',
    label: 'Address',
    readOnly: true,
  },
  {
    id: 'city',
    name: 'city',
    type: 'text',
    label: 'City',
    readOnly: true,
  },
  {
    id: 'country',
    name: 'country',
    type: 'text',
    label: 'Country',
    readOnly: true,
  },
  {
    id: 'postCode',
    name: 'postCode',
    type: 'text',
    label: 'Post code',
    readOnly: true,
  },
  {
    id: 'dateOfBirth',
    name: 'dateOfBirth',
    type: 'date',
    label: 'Date of Birth',
    readOnly: true,
  },
  {
    id: 'nationalInsuranceNumber',
    name: 'nationalInsuranceNumber',
    type: 'text',
    label: 'NI Number',
    readOnly: true,
  },
  {
    id: 'addressChangedInLastYear',
    name: 'addressChangedInLastYear',
    type: 'radio',
    label: 'Changed address in the last year',
    options: baseRadioOptionsBool,
    mainField: true,
    readOnly: true,
    subFields: {
      value: 'true',
      fields: [
        {
          id: 'addressChangeDate',
          name: 'addressChangeDate',
          type: 'date',
          label: 'Address Change Date',
          small: true,
          readOnly: true,
        },
      ],
    },
  },

  {
    id: 'refundRecievedLastYear',
    name: 'refundRecievedLastYear',
    type: 'radio',
    label: 'Received a refund last year',
    options: baseRadioOptionsBool,
    mainField: true,
    readOnly: true,
    subFields: {
      value: 'true',
      fields: [
        {
          id: 'refundAmount',
          name: 'refundAmount',
          type: 'text',
          label: 'Amount',
          prefix: '£',
          small: true,
          readOnly: true,
        },
      ],
    },
  },

  {
    id: 'paymentOnAccountLastYear',
    name: 'paymentOnAccountLastYear',
    type: 'radio',
    label: 'Made payments on account last year ',
    options: baseRadioOptionsBool,
    mainField: true,
    readOnly: true,
    subFields: {
      value: 'true',
      fields: [
        {
          id: 'paymentOnAccountLastYearWithTax',
          name: 'paymentOnAccountLastYearWithTax',
          type: 'text',
          label: 'Amount paid with last year’s tax payment',
          prefix: '£',
          small: true,
          readOnly: true,
        },
        {
          id: 'paymentOnAccountLastYearJune',
          name: 'paymentOnAccountLastYearJune',
          type: 'text',
          label: 'Amount paid in July',
          prefix: '£',
          small: true,
          readOnly: true,
        },
      ],
    },
  },
];

const accountantSelfAssessmentIncome = [
  {
    id: 'title',
    name: 'title',
    type: 'title',
    label: 'Income',
  },
  {
    id: 'fullTimeEmployment',
    name: 'fullTimeEmployment',
    label: 'Full-time employment',
    type: 'text',
    readOnly: true,
  },
  {
    id: 'numberOfEmploymentJobs',
    name: 'numberOfEmploymentJobs',
    label: 'Number of Employment jobs',
    type: 'text',
    readOnly: true,
  },
  {
    id: 'selfEmployed',
    name: 'selfEmployed',
    label: 'Self-employment business',
    type: 'text',
    readOnly: true,
  },
  {
    id: 'numberOfSelfEmploymentBusinesses',
    name: 'numberOfSelfEmploymentBusinesses',
    label: 'Number of Self-employment businesses',
    type: 'text',
    readOnly: true,
  },
  {
    id: 'property',
    name: 'property',
    label: 'UK Property',
    type: 'text',
    readOnly: true,
  },
  {
    id: 'numberOfproperties',
    name: 'numberOfproperties',
    label: 'Number of properties',
    type: 'text',
    readOnly: true,
  },
  {
    id: 'capitalGains',
    name: 'capitalGains',
    label: 'Capital Gains',
    type: 'text',
    readOnly: true,
  },
  {
    id: 'numberOfCapitalGains',
    name: 'numberOfCapitalGains',
    label: 'Number of Capital Gains Computations',
    type: 'text',
    readOnly: true,
  },
];

const accountantSelfAssessmentReliefs = [
  {
    id: 'title1',
    name: 'title1',
    type: 'title',
    label: 'Child Benefits',
  },
  {
    id: 'responsibleForChildren',
    name: 'responsibleForChildren',
    type: 'radio',
    label:
      'I am responsible for one or more children under the age of 16 and eligible to claim Child Benefit',
    options: baseRadioOptions,
    mainField: true,
    disabled: true,
    subFields: {
      value: 'yes',
      fields: [
        {
          id: 'numberOfChildren',
          name: 'numberOfChildren',
          type: 'text',
          label: 'How many children total are you responsible for?',
          narrow: true,
          helpText:
            'Enter the number of childer under the age of 16 or under 20 if they stay in approved education or training',
          small: true,
          readOnly: true,
        },

        {
          id: 'receiveChildBenefits',
          name: 'receiveChildBenefits',
          type: 'text',
          label: 'Did you receive Child Benefits?',
          narrow: true,
          readOnly: true,
        },
        {
          id: 'stoppedReceivingChildBenefits',
          name: 'stoppedReceivingChildBenefits',
          type: 'radio',
          label: 'I stopped getting Child Benefits this during this tax year',
          options: baseRadioOptions,
          disabled: true,
          subFields: {
            value: 'yes',
            fields: [
              {
                id: 'dateStoppedReceivingChildBenefits',
                name: 'dateStoppedReceivingChildBenefits',
                type: 'date',
                label: 'Date you stopped getting Child Benefits',
                readOnly: true,
              },
            ],
          },
        },
      ],
    },
  },
  {
    id: 'title2',
    name: 'title2',
    type: 'title',
    label: 'Pension',
  },
  {
    id: 'hasPension',
    name: 'hasPension',
    type: 'radio',
    label: 'I contribute to a Pension or SIPP',
    options: baseRadioOptions,
    mainField: true,
    disabled: true,
    subFields: {
      value: 'yes',
      fields: [
        {
          id: 'pensionType',
          name: 'pensionType',
          type: 'text',
          label: 'Type of Pension',
          readOnly: true,
          altSubFields: {
            value: 'Other (add details below)',
            fields: [
              {
                id: 'pensionDetails',
                name: 'pensionDetails',
                type: 'textarea',
                label: 'Pension details',
                readOnly: true,
              },
            ],
          },
        },
        {
          id: 'contributeToMultiplePensions',
          name: 'contributeToMultiplePensions',
          type: 'radio',
          label: 'I contribute to more than one pension',
          options: baseRadioOptions,
          disabled: true,
          subFields: {
            value: 'yes',
            fields: [
              {
                id: 'additionalInformation',
                name: 'additionalInformation',
                type: 'textarea',
                label: 'Input addtional pension information here',
                readOnly: true,
              },
            ],
          },
        },
      ],
    },
  },
  {
    id: 'title3',
    name: 'title3',
    type: 'title',
    label: 'Donations',
  },
  {
    id: 'donationsMade',
    name: 'donationsMade',
    type: 'radio',
    label: 'I made donations during this tax year',
    options: baseRadioOptions,
    mainField: true,
    disabled: true,
    subFields: {
      value: 'yes',
      fields: [
        {
          id: 'paymentsToGiftAid',
          name: 'paymentsToGiftAid',
          type: 'radio',
          label: 'I made payments to gift-aid',
          options: baseRadioOptions,
          readOnly: true,
        },
        {
          id: 'lastYearGiftAid',
          name: 'lastYearGiftAid',
          type: 'radio',
          label:
            'I made gift-aid payments last tax year that should count for this tax year',
          options: baseRadioOptions,
          disabled: true,
          subFields: {
            value: 'yes',
            fields: [
              {
                id: 'lastYearGiftAidAmount',
                name: 'lastYearGiftAidAmount',
                type: 'text',
                label: 'Amount',
                prefix: '£',
                small: true,
                readOnly: true,
              },
            ],
          },
        },
        {
          id: 'giftAidAfterTaxYear',
          name: 'giftAidAfterTaxYear',
          type: 'radio',
          label:
            'I made gift-aid payments after the end of this tax year that should be counted for this tax year',
          disabled: true,
          options: baseRadioOptions,
          subFields: {
            value: 'yes',
            fields: [
              {
                id: 'giftAidAfterTaxYearAmount',
                name: 'giftAidAfterTaxYearAmount',
                type: 'text',
                label: 'Amount',
                prefix: '£',
                small: true,
                readOnly: true,
              },
            ],
          },
        },
        {
          id: 'otherGifts',
          name: 'otherGifts',
          type: 'radio',
          label: 'I gifted shares, securities, land or investments to charity',
          options: baseRadioOptions,
          disabled: true,
          subFields: {
            value: 'yes',
            fields: [
              {
                id: 'otherGiftsDetails',
                name: 'otherGiftsDetails',
                type: 'textarea',
                label: 'Details of gift(s)',
                readOnly: true,
              },
            ],
          },
        },
      ],
    },
  },

  {
    id: 'title4',
    name: 'title4',
    type: 'title',
    label: 'Student Loan',
  },
  {
    id: 'employerDeductedStudentLoan',
    name: 'employerDeductedStudentLoan',
    type: 'radio',
    label: 'My employer deducted student loan payments',
    disabled: true,
    options: baseRadioOptions,
    mainField: true,
    subFields: {
      value: 'yes',
      fields: [
        {
          id: 'employerDeductedStudentLoanAmount',
          name: 'employerDeductedStudentLoanAmount',
          type: 'text',
          label: 'Amount your employer deducted in Studen Loan Payments',
          readOnly: true,
          prefix: '£',
          small: true,
        },
        {
          id: 'studentLoadPaidInNextTwoYears',
          name: 'studentLoadPaidInNextTwoYears',
          type: 'radio',
          label: 'My student loans will be paid off in the next two years',
          readOnly: true,
          options: baseRadioOptions,
        },
      ],
    },
  },

  {
    id: 'title5',
    name: 'title5',
    type: 'title',
    label: 'Marriage',
  },
  {
    id: 'marriage',
    name: 'marriage',
    type: 'radio',
    label:
      'I am married or in a civil partnership and want to transfer my tax free allowance',
    disabled: true,
    options: baseRadioOptions,
    mainField: true,
    subFields: {
      value: 'yes',
      fields: [
        {
          id: 'partnerName',
          name: 'partnerName',
          type: 'text',
          label: 'Name',
          readOnly: true,
        },
        {
          id: 'dateOfBirth',
          name: 'dateOfBirth',
          type: 'date',
          label: 'Date of Birth',
          small: true,
          readOnly: true,
        },
        {
          id: 'nationalInsuranceNumber',
          name: 'nationalInsuranceNumber',
          type: 'text',
          label: 'NI Number',
          small: true,
          readOnly: true,
        },

        {
          id: 'dateOfMarriage',
          name: 'dateOfMarriage',
          type: 'date',
          label: 'Date of Marriage or Civil Partnership',
          small: true,
          readOnly: true,
        },
      ],
    },
  },

  {
    id: 'title6',
    name: 'title6',
    type: 'title',
    label: 'CIS',
  },

  {
    id: 'cis',
    name: 'cis',
    type: 'radio',
    label:
      'I have had Construction Industry Scheme (CIS) deductions taken from my payments by contractors',
    disabled: true,
    options: baseRadioOptions,
    mainField: true,
    subFields: {
      value: 'yes',
      fields: [
        {
          id: 'cisAmount',
          name: 'cisAmount',
          type: 'text',
          label:
            'Amount of CIS deductions taken from your payments by contractors',
          readOnly: true,
          prefix: '£',
          small: true,
        },
      ],
    },
  },
  {
    id: 'title7',
    name: 'title7',
    type: 'title',
    label: 'Blind Allowance',
  },
  {
    id: 'blindAllowance',
    name: 'blindAllowance',
    type: 'radio',
    label: 'I, or my partner is blind',
    disabled: true,
    options: baseRadioOptions,
    mainField: true,
    subFields: {
      value: 'yes',
      fields: [
        {
          id: 'authorityName',
          name: 'authorityName',
          type: 'text',
          label: 'Name of local authority or register',
          small: true,
          readOnly: true,
        },
        {
          id: 'useSpoucesAllowance',
          name: 'useSpoucesAllowance',
          type: 'text',
          label: 'Transfer your allowance',
          readOnly: true,
        },
      ],
    },
  },
  {
    id: 'donationTotal',
    name: 'donationTotal',
    label: 'Total Donation Tax Relief Expenses',
    type: 'text',
    readOnly: true,
    prefix: '£',
  },
  {
    id: 'pensionContributionsTotal',
    name: 'pensionContributionsTotal',
    label: 'Total Pension Tax Relief Expenses',
    type: 'text',
    readOnly: true,
    prefix: '£',
  },
  {
    id: 'otherTotal',
    name: 'otherTotal',
    label: 'Total Other Tax Relief Expenses',
    type: 'text',
    readOnly: true,
    prefix: '£',
  },
  {
    id: 'expenseTaggedAmount',
    name: 'expenseTaggedAmount',
    label: 'Total Tax Relief',
    type: 'text',
    readOnly: true,
    prefix: '£',
  },
];

const accountantSelfAssessmentSelfEmployment = [
  {
    id: 'businessDescription',
    name: 'businessDescription',
    label: 'Description of business',
    type: 'textarea',
    readOnly: true,
  },
  {
    id: 'businessPostCode',
    name: 'businessPostCode',
    label: 'Postcode of your business address',
    type: 'text',
    readOnly: true,
  },
  {
    id: 'businessAddressChanged',
    name: 'businessAddressChanged',
    label:
      'If your business name, description address or postcode has changed in the last 12 months',
    type: 'text',
    readOnly: true,
  },
  {
    id: 'isFosterCarer',
    name: 'isFosterCarer',
    label: 'If you are a foster career or shared lives carer',
    type: 'text',
    readOnly: true,
  },
  {
    id: 'businessStartDate',
    name: 'businessStartDate',
    label: 'If your business started after 5 April 2018 enter start date',
    type: 'text',
    readOnly: true,
  },
  {
    id: 'businessCloseDate',
    name: 'businessCloseDate',
    label:
      'If your business ceased before 6 April 2019, enter the final date of trading',
    type: 'text',
    readOnly: true,
  },
  {
    id: 'booksDate',
    name: 'booksDate',
    label: 'Date your books or accounts are made up to',
    type: 'text',
    readOnly: true,
  },
  {
    id: 'cashBasisMoney',
    name: 'cashBasisMoney',
    label:
      'If you used cash basis money actually received and paidout to calculate your income and expenses',
    type: 'text',
    readOnly: true,
    defaultValue: 'yes',
  },
  {
    id: 'incomeTaggedAmount',
    name: 'incomeTaggedAmount',
    label: 'Your turnover',
    type: 'text',
    readOnly: true,
    prefix: '£',
  },
  {
    id: 'title1',
    name: 'title1',
    type: 'title',
    label: 'Self-employment expenses',
  },
  {
    id: 'hasBoughtGoods',
    name: 'hasBoughtGoods',
    type: 'radio',
    options: baseRadioOptions,
    label: 'Do you have materials bought in conjunction with your product?',
    mainField: true,
    disabled: true,
    subFields: {
      value: 'yes',
      fields: [
        {
          id: 'allGoodsBoughtUsedLastYear',
          name: 'allGoodsBoughtUsedLastYear',
          type: 'radio',
          options: baseRadioOptions,
          label: 'All goods bought for my business were used in the tax year',
          disabled: true,
          subFields: {
            value: 'no',
            fields: [
              {
                id: 'hasUnsoldGoods',
                name: 'hasUnsoldGoods',
                type: 'radio',
                options: baseRadioOptions,
                label:
                  'I have goods or raw materials I bought for resale this year but did not sell',
                disabled: true,
              },
              {
                id: 'unsoldGoodsAmount',
                name: 'unsoldGoodsAmount',
                type: 'text',
                label: 'Total cost of goods bought for re-sale but not used',
                prefix: '£',
                small: true,
                readOnly: true,
              },
            ],
          },
        },
        {
          id: 'hasLastYearsGoodsSoldThisYear',
          name: 'hasLastYearsGoodsSoldThisYear',
          type: 'radio',
          options: baseRadioOptions,
          label:
            'I have goods or raw materials I bought for resale last year and sold this year',
          disabled: true,
          subFields: {
            value: 'yes',
            fields: [
              {
                id: 'lastYearsGoodsSoldThisYearAmount',
                name: 'lastYearsGoodsSoldThisYearAmount',
                type: 'text',
                label:
                  'Total cost of goods bought for re-sale last year and used this year',
                prefix: '£',
                small: true,
                readOnly: true,
              },
            ],
          },
        },
      ],
    },
  },
  {
    id: 'travelForBusiness',
    name: 'travelForBusiness',
    label: 'Do you drive your personal vehicle for business?',
    type: 'radio',
    options: baseRadioOptions,
    mainField: true,
    disabled: true,
    subFields: {
      value: 'yes',
      fields: [
        {
          id: 'isMainVehicleAMotocycle',
          name: 'isMainVehicleAMotocycle',
          type: 'radio',
          options: baseRadioOptions,
          label: 'My main vehicle is a motorcycle',
          readOnly: true,
        },
        {
          id: 'milesDrivenForBusiness',
          name: 'milesDrivenForBusiness',
          type: 'text',
          label: 'Miles driven for business',
          small: true,
          suffix: 'miles',
          readOnly: true,
        },
      ],
    },
  },
  {
    id: 'hasSubContractorExpenses',
    name: 'hasSubContractorExpenses',
    type: 'radio',
    options: baseRadioOptions,
    label: 'I have staff or subcontractor expenses',
    disabled: true,
    mainField: true,
  },
  {
    id: 'workFromHome',
    name: 'workFromHome',
    type: 'radio',
    options: baseRadioOptions,
    label: 'I work from home and want to expense part of my home expenses',
    disabled: true,
    mainField: true,
    subFields: {
      value: 'yes',
      fields: [
        {
          id: 'totalHoursWorkingFromHomePerMonth',
          name: 'totalHoursWorkingFromHomePerMonth',
          type: 'text',
          label: 'Total hours working from home per month',
          small: true,
          suffix: 'hours',
          readOnly: true,
        },
        {
          id: 'percentageHomeUtilitiesUsedForBusiness',
          name: 'percentageHomeUtilitiesUsedForBusiness',
          type: 'text',
          label:
            'What percentage of your home and utilities are used for business?',
          small: true,
          suffix: '%',
          readOnly: true,
        },
      ],
    },
  },

  {
    id: 'costOfGoodsBoughtForResaleOrGoodsUsedTotal',
    name: 'costOfGoodsBoughtForResaleOrGoodsUsedTotal',
    label: 'Costs of goods bought for resale or goods used',
    type: 'text',
    readOnly: true,
    prefix: '£',
  },
  {
    id: 'advertisingBusinessEntertainmentTotal',
    name: 'advertisingBusinessEntertainmentTotal',
    label: 'Advertising and Business Entertainment',
    type: 'text',
    readOnly: true,
    prefix: '£',
  },
  {
    id: 'wagesSalariesAndOtherStaffCostsTotal',
    name: 'wagesSalariesAndOtherStaffCostsTotal',
    label: 'Wages salaries and other staff costs',
    type: 'text',
    readOnly: true,
    prefix: '£',
  },
  {
    id: 'rentRatesPowerInsuranceTotal',
    name: 'rentRatesPowerInsuranceTotal',
    label: 'Rent, rates, power and insurance costs',
    type: 'text',
    readOnly: true,
    prefix: '£',
  },
  {
    id: 'repairsMaintenanceOfPpeTotal',
    name: 'repairsMaintenanceOfPpeTotal',
    label: 'Repairs and maintenance of property and equipment',
    type: 'text',
    readOnly: true,
    prefix: '£',
  },
  {
    id: 'accountancyLegalOtherProfessionalFeesTotal',
    name: 'accountancyLegalOtherProfessionalFeesTotal',
    label: 'Accountantcy, legal and other professional fees',
    type: 'text',
    readOnly: true,
    prefix: '£',
  },
  {
    id: 'bankCreditOtherFinancialChargesTotal',
    name: 'bankCreditOtherFinancialChargesTotal',
    label: 'Interest and bank and credit card financial charges',
    type: 'text',
    readOnly: true,
    prefix: '£',
  },
  {
    id: 'phoneFaxStationaryOtherOfficeCostsTotal',
    name: 'phoneFaxStationaryOtherOfficeCostsTotal',
    label: 'Phone, fax, stationery and other office costs',
    type: 'text',
    readOnly: true,
    prefix: '£',
  },
  {
    id: 'carVanTravelExpensesTotal',
    name: 'carVanTravelExpensesTotal',
    label: 'Car, Van and Travel Expenses',
    type: 'text',
    readOnly: true,
    prefix: '£',
  },
  {
    id: 'otherBusinessExpenseTotal',
    name: 'otherBusinessExpenseTotal',
    label: 'Other allowable business expesnes',
    type: 'text',
    readOnly: true,
    prefix: '£',
  },
  {
    id: 'expenseTaggedAmount',
    name: 'expenseTaggedAmount',
    label: 'Total Allowable expenses',
    type: 'text',
    readOnly: true,
    prefix: '£',
  },
];

const accountantSelfAssessmentEmployer = [
  {
    id: 'name',
    name: 'name',
    label: 'Employer Name',
    type: 'text',
    readOnly: true,
  },
  {
    id: 'payeTaxReference',
    name: 'payeTaxReference',
    label: 'PAYE tax reference of employer',
    type: 'text',
    small: true,
    readOnly: true,
  },
  {
    id: 'totalPayBeforeTax',
    name: 'totalPayBeforeTax',
    label: 'Total Pay (before tax)',
    type: 'text',
    prefix: '£',
    small: true,
    readOnly: true,
  },
  {
    id: 'taxDeducted',
    name: 'taxDeducted',
    label: 'Tax Deducted (box 1)',
    type: 'text',
    prefix: '£',
    small: true,
    readOnly: true,
  },
  {
    id: 'finalTaxCode',
    name: 'finalTaxCode',
    label: 'Final Tax Code',
    type: 'text',
    small: true,
    readOnly: true,
  },
  {
    id: 'niContributions',
    name: 'niContributions',
    label: 'NI Contributions (above PT)',
    type: 'text',
    prefix: '£',
    small: true,
    readOnly: true,
  },
  {
    id: 'receiveBenefits',
    name: 'receiveBenefits',
    type: 'radio',
    options: baseRadioOptions,
    label: 'I received benefits from this employment',
    mainField: true,
    disabled: true,
    subFields: {
      value: 'yes',
      fields: [
        {
          id: 'companyCar',
          name: 'companyCar',
          label: 'Company cars and vans',
          type: 'text',
          prefix: '£',
          small: true,
          readOnly: true,
        },
        {
          id: 'fuelForCar',
          name: 'fuelForCar',
          label: 'Fuel for company cars and vans',
          type: 'text',
          prefix: '£',
          small: true,
          readOnly: true,
        },
        {
          id: 'privateInsurance',
          name: 'privateInsurance',
          label: 'Private medical and dental insurance',
          type: 'text',
          prefix: '£',
          small: true,
          readOnly: true,
        },
        {
          id: 'vouchersCreditCards',
          name: 'vouchersCreditCards',
          label: 'Vouchers credit cards and excess mileage',
          type: 'text',
          prefix: '£',
          small: true,
          readOnly: true,
        },
        {
          id: 'goodsAndOtherAssets',
          name: 'goodsAndOtherAssets',
          label: 'Goods and other assets provided by employer',
          type: 'text',
          prefix: '£',
          small: true,
          readOnly: true,
        },
        {
          id: 'accommodations',
          name: 'accommodations',
          label: 'Accommodation provided by employer',
          type: 'text',
          prefix: '£',
          small: true,
          readOnly: true,
        },
        {
          id: 'otherBenefits',
          name: 'otherBenefits',
          label: 'Other benefits ',
          type: 'text',
          prefix: '£',
          small: true,
          readOnly: true,
        },
        {
          id: 'expensesPaymentsReceived',
          name: 'expensesPaymentsReceived',
          label: 'Expenses payments received and balancing charges',
          type: 'text',
          prefix: '£',
          small: true,
          readOnly: true,
        },
      ],
    },
  },

  {
    id: 'claimExpenses',
    name: 'claimExpenses',
    type: 'radio',
    options: baseRadioOptions,
    label: 'I want to claim expenses from this employment',
    mainField: true,
    disabled: true,
    subFields: {
      value: 'yes',
      fields: [
        {
          id: 'businsesTravel',
          name: 'businsesTravel',
          label: 'Business travel and subsistence expenses',
          type: 'text',
          prefix: '£',
          small: true,
          readOnly: true,
        },
        {
          id: 'fixedDeductionsForExpenses',
          name: 'fixedDeductionsForExpenses',
          label: 'fixed deductions for expenses ',
          type: 'text',
          prefix: '£',
          small: true,
          readOnly: true,
        },
        {
          id: 'professionalFees',
          name: 'professionalFees',
          label: 'Professional fees and subscriptions',
          type: 'text',
          prefix: '£',
          small: true,
          readOnly: true,
        },
        {
          id: 'otherExpenses',
          name: 'otherExpenses',
          label: 'Other expenses and capital allowances',
          type: 'text',
          prefix: '£',
          small: true,
          readOnly: true,
        },
      ],
    },
  },
  {
    id: 'hasReceivedOtherIncome',
    name: 'hasReceivedOtherIncome',
    type: 'radio',
    options: baseRadioOptions,
    mainField: true,
    disabled: true,
    label:
      'I received other income from my PAYE employment that is not listed on the P45 or P60 (ex: tips)',
    subFields: {
      value: 'yes',
      fields: [
        {
          id: 'otherIncomeAmount',
          name: 'otherIncomeAmount',
          label: 'Tips and other payments not on p60',
          type: 'text',
          prefix: '£',
          small: true,
          readOnly: true,
        },
      ],
    },
  },
  {
    id: 'isOnPaypaymentOfTeachersLoanScheme',
    name: 'isOnPaypaymentOfTeachersLoanScheme',
    label: 'Part time teacher in England or Wales with Teach loan scheme',
    type: 'radio',
    options: baseRadioOptions,
    mainField: true,
    readOnly: true,
  },
];

const accountantSelfAssessmentProperty = [
  {
    id: 'isShortTermHolidayLet',
    name: 'isShortTermHolidayLet',
    type: 'radio',
    options: baseRadioOptions,
    label: 'Is this a furnished short term holiday let?',
    mainField: true,
    disabled: true,
    subFields: {
      value: 'yes',
      fields: [
        {
          id: 'propertyLocation',
          name: 'propertyLocation',
          type: 'text',
          label: 'Where is this property located?',
          readOnly: true,
        },
        {
          id: 'daysAvailable',
          name: 'daysAvailable',
          type: 'text',
          suffix: 'Days',
          small: true,
          label:
            'How many days was the property available for letting as furnished holiday accommodation for in the year?',
          readOnly: true,
        },
        {
          id: 'daysLet',
          name: 'daysLet',
          type: 'text',
          suffix: 'Days',
          small: true,
          label:
            'How many days was the let commercially as furnished holiday accommodation for in the year?',
          readOnly: true,
        },
        {
          id: 'totalLongTermLetExceedLimit',
          name: 'totalLongTermLetExceedLimit',
          type: 'radio',
          options: baseRadioOptions,
          label:
            'Is the total of all lettings that exceed 31 continuous days more than 155 days?',
          readOnly: true,
        },
      ],
    },
    altSubFields: {
      value: 'no',
      fields: [
        {
          id: 'isLiveInLandLord',
          name: 'isLiveInLandLord',
          type: 'radio',
          options: baseRadioOptions,
          label: 'I make rental income as a ‘Live-in Landlord’',
          readOnly: true,
        },
        {
          id: 'eligableForRentARoomRelief',
          name: 'eligableForRentARoomRelief',
          type: 'radio',
          options: baseRadioOptions,
          label: 'I am eligible for rent-a-room relief',
          readOnly: true,
        },
      ],
    },
  },
  {
    id: 'rentPaidRepairsInsuranceAndCostsOfServicesProvidedTotal',
    name: 'rentPaidRepairsInsuranceAndCostsOfServicesProvidedTotal',
    label: 'Rent paid, repairs, insurance and costs of services provided',
    type: 'text',
    readOnly: true,
    prefix: '£',
  },
  {
    id: 'propertyRepairsAndMaintenanceTotal',
    name: 'propertyRepairsAndMaintenanceTotal',
    label: 'Property repairs and maintenance',
    type: 'text',
    readOnly: true,
    prefix: '£',
  },
  {
    id: 'costsOfServicesProvidedIncludingWagesTotal',
    name: 'costsOfServicesProvidedIncludingWagesTotal',
    label: 'Costs of services provided, including wages',
    type: 'text',
    readOnly: true,
    prefix: '£',
  },
  {
    id: 'loanInterestAndOtherFinancialCostsTotal',
    name: 'loanInterestAndOtherFinancialCostsTotal',
    label: 'Loan interest and other financial costs',
    type: 'text',
    readOnly: true,
    prefix: '£',
  },
  {
    id: 'legalManagementAndOtherProfessionalFeesTotal',
    name: 'legalManagementAndOtherProfessionalFeesTotal',
    label: 'Legal, management and other professional fees',
    type: 'text',
    readOnly: true,
    prefix: '£',
  },
  {
    id: 'otherAllowablePropertyExpensesTotal',
    name: 'otherAllowablePropertyExpensesTotal',
    label: 'Other allowable property expenses',
    type: 'text',
    readOnly: true,
    prefix: '£',
  },
  {
    id: 'expenseTaggedAmount',
    name: 'expenseTaggedAmount',
    label: 'Total Allowable expenses',
    type: 'text',
    readOnly: true,
    prefix: '£',
  },
];

const accountantSelfAssessmentCapitalGains = [
  {
    id: 'title1',
    name: 'title1',
    type: 'title',
    label: 'Capital Gains',
    readOnly: true,
  },
  {
    id: 'title2',
    name: 'title2',
    type: 'title',
    label: 'Residential',
    readOnly: true,
    small: true,
  },
  {
    id: 'resiNumberOfDisposals',
    name: 'resiNumberOfDisposals',
    type: 'text',
    label: 'Number of Disposals',
    readOnly: true,
  },
  {
    id: 'resiDisposalProceeds',
    name: 'resiDisposalProceeds',
    type: 'text',
    label: 'Disposal proceeds',
    prefix: '£',
    readOnly: true,
  },
  {
    id: 'resiAllowableCosts',
    name: 'resiAllowableCosts',
    type: 'text',
    label: 'Allowable costs',
    prefix: '£',
    readOnly: true,
  },
  {
    id: 'resiGainsInTheYear',
    name: 'resiGainsInTheYear',
    type: 'text',
    label: 'Gains in the year, before losses',
    prefix: '£',
    readOnly: true,
  },
  {
    id: 'resiLossesInTheYear',
    name: 'resiLossesInTheYear',
    type: 'text',
    label: 'Losses in the year',
    prefix: '£',
    readOnly: true,
  },

  {
    id: 'resiTaxOnGainAlreadyCharged',
    name: 'resiTaxOnGainAlreadyCharged',
    type: 'text',
    label: 'Tax on gains in box 11 already charged',
    prefix: '£',
    readOnly: true,
  },
  {
    id: 'title3',
    name: 'title3',
    type: 'title',
    label: 'Property',
    readOnly: true,
    small: true,
  },
  {
    id: 'propNumberOfDisposals',
    name: 'propNumberOfDisposals',
    type: 'text',
    label: 'Number of Disposals',
    readOnly: true,
  },
  {
    id: 'propDisposalProceeds',
    name: 'propDisposalProceeds',
    type: 'text',
    label: 'Disposal proceeds',
    prefix: '£',
    readOnly: true,
  },
  {
    id: 'propAllowableCosts',
    name: 'propAllowableCosts',
    type: 'text',
    label: 'Allowable costs',
    prefix: '£',
    readOnly: true,
  },
  {
    id: 'propGainsInTheYear',
    name: 'propGainsInTheYear',
    type: 'text',
    label: 'Gains in the year, before losses',
    prefix: '£',
    readOnly: true,
  },
  {
    id: 'propLossesInTheYear',
    name: 'propLossesInTheYear',
    type: 'text',
    label: 'Losses in the year',
    prefix: '£',
    readOnly: true,
  },

  {
    id: 'propTaxOnGainAlreadyCharged',
    name: 'propTaxOnGainAlreadyCharged',
    type: 'text',
    label: 'Tax on gains in box 11 already charged',
    prefix: '£',
    readOnly: true,
  },
  {
    id: 'title4',
    name: 'title4',
    type: 'title',
    label: 'Shares',
    readOnly: true,
    small: true,
  },
  {
    id: 'sharesNumberOfDisposals',
    name: 'sharesNumberOfDisposals',
    type: 'text',
    label: 'Number of Disposals',
    readOnly: true,
  },
  {
    id: 'sharesDisposalProceeds',
    name: 'sharesDisposalProceeds',
    type: 'text',
    label: 'Disposal proceeds',
    prefix: '£',
    readOnly: true,
  },
  {
    id: 'sharesAllowableCosts',
    name: 'sharesAllowableCosts',
    type: 'text',
    label: 'Allowable costs',
    prefix: '£',
    readOnly: true,
  },
  {
    id: 'sharesGainsInTheYear',
    name: 'sharesGainsInTheYear',
    type: 'text',
    label: 'Gains in the year, before losses',
    prefix: '£',
    readOnly: true,
  },
  {
    id: 'sharesLossesInTheYear',
    name: 'sharesLossesInTheYear',
    type: 'text',
    label: 'Losses in the year',
    prefix: '£',
    readOnly: true,
  },

  {
    id: 'sharesTaxOnGainAlreadyCharged',
    name: 'sharesTaxOnGainAlreadyCharged',
    type: 'text',
    label: 'Tax on gains in box 11 already charged',
    prefix: '£',
    readOnly: true,
  },
  {
    id: 'title5',
    name: 'title5',
    type: 'title',
    label: 'Unlisted',
    readOnly: true,
    small: true,
  },
  {
    id: 'unlistedNumberOfDisposals',
    name: 'unlistedNumberOfDisposals',
    type: 'text',
    label: 'Number of Disposals',
    readOnly: true,
  },
  {
    id: 'unlistedDisposalProceeds',
    name: 'unlistedDisposalProceeds',
    type: 'text',
    label: 'Disposal proceeds',
    prefix: '£',
    readOnly: true,
  },
  {
    id: 'unlistedAllowableCosts',
    name: 'unlistedAllowableCosts',
    type: 'text',
    label: 'Allowable costs',
    prefix: '£',
    readOnly: true,
  },
  {
    id: 'unlistedGainsInTheYear',
    name: 'unlistedGainsInTheYear',
    type: 'text',
    label: 'Gains in the year, before losses',
    prefix: '£',
    readOnly: true,
  },
  {
    id: 'unlistedLossesInTheYear',
    name: 'unlistedLossesInTheYear',
    type: 'text',
    label: 'Losses in the year',
    prefix: '£',
    readOnly: true,
  },

  {
    id: 'unlistedTaxOnGainAlreadyCharged',
    name: 'unlistedTaxOnGainAlreadyCharged',
    type: 'text',
    label: 'Tax on gains in box 11 already charged',
    prefix: '£',
    readOnly: true,
  },
];

const accountantProfile = [
  {
    id: 'title1',
    name: 'title1',
    type: 'title',
    label: 'Profile',
    readOnly: true,
  },
  {
    id: 'utrNumber',
    name: 'utrNumber',
    type: 'text',
    label: 'UTR Number',
    readOnly: true,
  },
  {
    id: 'email',
    name: 'email',
    type: 'email',
    label: 'Email',
    readOnly: true,
  },
  {
    id: 'firstName',
    name: 'firstName',
    type: 'text',
    label: 'First name',
    readOnly: true,
  },
  {
    id: 'lastName',
    name: 'lastName',
    type: 'text',
    label: 'Last name',
    readOnly: true,
  },
  {
    id: 'address',
    name: 'address',
    type: 'text',
    label: 'Address',
    readOnly: true,
  },
  {
    id: 'city',
    name: 'city',
    type: 'text',
    label: 'City',
    readOnly: true,
  },
  {
    id: 'country',
    name: 'country',
    type: 'text',
    label: 'Country',
    readOnly: true,
  },
  {
    id: 'postCode',
    name: 'postCode',
    type: 'text',
    label: 'Post code',
    readOnly: true,
  },
  {
    id: 'dateOfBirth',
    name: 'dateOfBirth',
    type: 'date',
    label: 'Date of Birth',
    readOnly: true,
  },
  {
    id: 'phoneNumber',
    name: 'phoneNumber',
    type: 'text',
    label: 'Phone Number',
    readOnly: true,
  },
  {
    id: 'nationalInsuranceNumber',
    name: 'nationalInsuranceNumber',
    type: 'text',
    label: 'NI Number',
    readOnly: true,
  },

  {
    id: 'addressChangedInLastYear',
    name: 'addressChangedInLastYear',
    type: 'radio',
    label: 'Changed address in the last year',
    options: baseRadioOptionsBool,
    mainField: true,
    readOnly: true,
    subFields: {
      value: 'true',
      fields: [
        {
          id: 'addressChangeDate',
          name: 'addressChangeDate',
          type: 'date',
          label: 'Address Change Date',
          small: true,
          readOnly: true,
        },
      ],
    },
  },

  {
    id: 'refundRecievedLastYear',
    name: 'refundRecievedLastYear',
    type: 'radio',
    label: 'Received a refund last year',
    options: baseRadioOptionsBool,
    mainField: true,
    readOnly: true,
    subFields: {
      value: 'true',
      fields: [
        {
          id: 'refundAmount',
          name: 'refundAmount',
          type: 'text',
          label: 'Amount',
          prefix: '£',
          small: true,
          readOnly: true,
        },
      ],
    },
  },

  {
    id: 'paymentOnAccountLastYear',
    name: 'paymentOnAccountLastYear',
    type: 'radio',
    label: 'Made payments on account last year ',
    options: baseRadioOptionsBool,
    mainField: true,
    readOnly: true,
    subFields: {
      value: 'true',
      fields: [
        {
          id: 'paymentOnAccountLastYearWithTax',
          name: 'paymentOnAccountLastYearWithTax',
          type: 'text',
          label: 'Amount paid with last year’s tax payment',
          prefix: '£',
          small: true,
          readOnly: true,
        },
        {
          id: 'paymentOnAccountLastYearJune',
          name: 'paymentOnAccountLastYearJune',
          type: 'text',
          label: 'Amount paid in July',
          prefix: '£',
          small: true,
          readOnly: true,
        },
      ],
    },
  },
];

const updateStatusFields = [
  {
    id: 'status',
    name: 'status',
    type: 'select',
    label: 'Status:',
    mainField: true,
    options: statusOptions,
    subFields: {
      value: 'SUBMITTED_TO_HMRC',
      fields: [
        {
          id: 'dateFiled',
          name: 'dateFiled',
          type: 'date',
          label: 'Date filed',
        },
        {
          id: 'proofOfFilingDocument',
          name: 'proofOfFilingDocument',
          type: 'file',
          label: 'Proof of filing document',
          hintText: 'This will be sent to the client for approval',
        },
      ],
    },
    altSubFields: {
      value: 'AWAITING_APPROVAL',
      fields: [
        {
          id: 'completedDocument',
          name: 'completedDocument',
          type: 'file',
          label: 'Completed Self Assessment',
          hintText: 'This will be sent to the client for approval',
        },
        {
          id: 'taxCalculationDocument',
          name: 'taxCalculationDocument',
          type: 'file',
          label: 'Tax Calculation Document',
          hintText: 'This will be sent to the client for approval',
        },
      ],
    },
  },
  {
    id: 'accountantNote',
    name: 'accountantNote',
    type: 'textarea',
    label: 'Note to the client',
    hintText: 'Optional note that will be passed back to the client.',
  },
];

const accountantInvestmentFields = [
  {
    id: 'assetType',
    name: 'assetType',
    type: 'text',
    label: 'Asset type',
    readOnly: true,
  },
  {
    id: 'assetDescription',
    name: 'assetDescription',
    type: 'textarea',
    label: 'Asset description',
    readOnly: true,
  },
  {
    id: 'purchaseDate',
    name: 'purchaseDate',
    type: 'date',
    label: 'Purchase date',
    small: true,
    readOnly: true,
  },
  {
    id: 'saleDate',
    name: 'saleDate',
    type: 'date',
    label: 'Sale date',
    small: true,
    readOnly: true,
  },
  {
    id: 'purchaseAmount',
    name: 'purchaseAmount',
    type: 'text',
    label: 'Purchase amount',
    prefix: '£',
    small: true,
    readOnly: true,
  },
  {
    id: 'saleAmount',
    name: 'saleAmount',
    type: 'text',
    label: 'Sale amount',
    prefix: '£',
    small: true,
    readOnly: true,
  },

  {
    id: 'expenses',
    name: 'expenses',
    type: 'text',
    label: 'Expenses',
    prefix: '£',
    readOnly: true,
  },
  {
    id: 'investmentTotal',
    name: 'investmentTotal',
    type: 'text',
    label: 'Investment Total',
    prefix: '£',
    readOnly: true,
  },
  {
    id: 'expensesDescription',
    name: 'expensesDescription',
    type: 'textarea',
    label: 'Expenses description',
    readOnly: true,
  },
  {
    id: 'hasAlreadyFiledAReturnForThisTransaction',
    name: 'hasAlreadyFiledAReturnForThisTransaction',
    type: 'radio',
    options: baseRadioOptions,
    label: 'I already filed a return for this transaction',
    disabled: true,
    mainField: true,
    subFields: {
      value: 'yes',
      fields: [
        {
          id: 'taxAmountCharged',
          name: 'taxAmountCharged',
          type: 'text',
          label: 'Tax amount charged',
          prefix: '£',
          small: true,
          readOnly: true,
        },
      ],
    },
  },
];

const uploadVerificationDocumentFields = [
  {
    id: 'verificationCertificate',
    name: 'verificationCertificate',
    type: 'file',
    hintText:
      'This will not be shown to the client and is for internal reference only.',
  },
];

export {
  accountantSelfAssessmentGeneral,
  accountantSelfAssessmentIncome,
  accountantSelfAssessmentReliefs,
  accountantSelfAssessmentEmployer,
  accountantSelfAssessmentSelfEmployment,
  accountantSelfAssessmentProperty,
  accountantSelfAssessmentCapitalGains,
  accountantProfile,
  updateStatusFields,
  accountantInvestmentFields,
  statusOptions,
  uploadVerificationDocumentFields,
};
